import { render } from "./PedigreeAddHorseForm.vue?vue&type=template&id=6ac5d5f2"
import script from "./PedigreeAddHorseForm.vue?vue&type=script&lang=js"
export * from "./PedigreeAddHorseForm.vue?vue&type=script&lang=js"

import "./PedigreeAddHorseForm.vue?vue&type=style&index=0&id=6ac5d5f2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__